import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No',  label: 'No'  },
];

const EnergyStarGlass = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected,    setSelected]    = useState(value?.value || '');
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    setShowWarning(v === 'Yes');
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdEnergyStarGlass">Energy Star Glass</label>
      <select id="SdEnergyStarGlass" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
      {showWarning && (
        <div className="jamb-warning">
          Energy Star Rating for specific orders. Please Note: Energy Star is not available for all glass options.
        </div>
      )}
    </div>
  );
};

export default EnergyStarGlass;
